import * as actionTypes from '../Action/actionTypes'

const initialState={
    loading:false,
    error:null,
    isAuth:false,
    isRedirect:false,
    allValid:true


}
const reducer = (state = initialState,action)=>{
    switch(action.type)
    {
        case actionTypes.AUTH_START:
            return{
                ...state,
                loading:true,
                error:null
            };
        case actionTypes.CLEAR_ERROR:
            
            return{
                ...state,
                error:null
            }
        
        case actionTypes.AUTH_SUCCESS:
            return{
                ...state,
                loading:false,
                error:null,
               isAuth:true
               
            }
        case actionTypes.AUTH_FAIL:
            return{
                ...state,
                loading:false,
                allValid:false,
                error:action.error
            }
       
        case actionTypes.LOGOUT:
            return{
                ...state,
                isAuth:false,
               
            }
        case actionTypes.RIDIRECT:
            return{
                ...state,
                isRedirect:true
            }
            default:
                return state;

    }

}
export default reducer